import { Input } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { useMissingCustomerDetailsForm } from '../../../../../../contexts/missingCustomerDetailsFormContext'

export const CustomerLastName = (): ReactElement => {
  const { t } = useTranslation()
  const {
    missingCustomerDetailsForm: { FormItem },
  } = useMissingCustomerDetailsForm()

  return (
    <FormItem
      label={t('external_invoices.missing_customer_compliance_details.modal.form.field.last_name.label')}
      name="lastName"
      render={({ field }) => <Input {...field} size="sm" />}
    />
  )
}
